angular.module('galilai.creator').factory('topics', function ($timeout, $rootScope, api) {
    let self = this

    const MAX_SAMPLE = 8
    const MAX_SAMPLE_TOPICS_FOR_GENERATION = 5
    const MIN_TOPICS_FOR_GENERATION = 2
    const MAX_PERCENT_TOPICS_FOR_GENERATION = 0.5
    let initData = {
        info: null,
        project: null,
        topicsMap: {},
        topicFilter: 'all',
        source: 'default',
        lists: {
            topics: [],
            selected: [],
            explore: [],
        },
        inputs: {
            bulkSelection: false,
            newTopic: null,
        },
        temp: {
            selection: [],
            editing: [],
        },
        timers : {
            save: null
        },
        sources: null,
    }

    self.getProjectId = function() {
        return self.project._id
    }

    self.getTopics = function() {
        return self.lists.topics
    }

    self.isMyTopic = function(topic) {
        return self.topicsMap && self.topicsMap[topic.label.toLowerCase()]
    }

    self.changeSource = function(kind) {
        self.source = kind
        let sourceData = self.sources
        if (kind != 'default') {
            sourceData = self.sources[kind]
            if (!sourceData) {
                self.sources[kind] = {
                    topics: [],
                    selected: [],
                }
            }
        }
        for (let key of ['topics', 'selected']) {
            if (!sourceData[key]) {
                sourceData[key] = []
            }
            self.lists[key] = sourceData[key]
        }
        if (!self.lists.topics) {
            self.lists.topics = []
        }
        if (typeof sourceData.selected == 'undefined' && self.lists.topics) {
            self.lists.selected = fullcopy(self.lists.topics.filter(topic => topic.selected))
        }
        self.parseTopics()
        $timeout(angular.noop)
    }

    self.listTopics = function(cb) {
        if (!self.getProjectId()) {
            // TODO - Show Error
            return
        }
        if (!self?.project?.data) {
            return
        }
        let profileUser = null
        if (self.project.data.profile.context) {
            profileUser = self.project.data.profile.context
        } else if (self.project.data.profile.social && self.project.data.profile.social.bio) {
            profileUser = self.project.data.profile.social.bio
        } else {
            // TODO - Error
        }

        let focus = self?.project?.data?.global?.focus
        let params = {
            profile: profileUser,
            language: self.config.language
        }
        if (focus) {
            params.focus = focus
        }
        api.getTopics(self.getProjectId(), params).then(function(response) {
            self.sources = response.data
            // TODO - Success
            for (let key in response.data) {
                self.lists[key] = response.data[key] || []
            }
            if (!self.lists.topics) {
                self.lists.topics = []
            }
            if (typeof response.data.selected == 'undefined' && self.lists.topics) {
                self.lists.selected = fullcopy(self.lists.topics.filter(topic => topic.selected))
            }
            self.parseTopics()
            $timeout(angular.noop)
            if (cb) {
                cb()
            }
        }).catch(function(err) {
            if (cb) {
                cb(err)
            }
            // TODO - Error
            console.log('Error getting topics', err)
        })
    }

    self.suggestTopics = function(context) {
        let inputTopics = {
            profile: context,
            language: self.config.language,
        }

        return api.suggestTopics(self.getProjectId(), inputTopics).then(function(response) {
            let topics = response.data.topics || []
            return topics
        })
    }

    self.saveTopics = function() {
        let params = {}
        if (self.topicFilter == 'all') {
            params.topics = self.lists.topics
        } else if (self.topicFilter == 'selected') {
            params.selected = self.lists.selected
        } else if (self.topicFilter == 'explore') {
            params.explore = self.lists.explore
        }

        params.source = self.source
        api.updateTopics(self.getProjectId(), params).then(function(response) {
            // TODO - Success
            console.log('=> Updated topics', response)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error updating topics', err)
        })
    }

    self.notifyChanged = function(name) {
        if (self.timers.save) {
            $timeout.cancel(self.timers.save)
        }
        name = name == 'all' ? 'topics' : name
        self.timers.save = $timeout(function() {
            self.saveTopics(name)
        }, 500)
    }

    self.getCurrentTopics = function() {
        if (self.topicFilter == 'all') {
            return self.lists.topics
        } else if (self.topicFilter == 'selected') {
            return self.lists.selected
        } else if (self.topicFilter == 'explore') {
            return self.lists.explore
        }
        return []
    }

    self.getTopicsForGeneration = function() {
        // TODO - Improve shuffle
        let baseData = self.getCurrentTopics()
        if (baseData.length == 0) {
            return false
        }
        let shuffled = baseData.slice().sort(() => 0.5 - Math.random())
        let amountGeneration = Math.min(Math.max(MIN_TOPICS_FOR_GENERATION, Math.floor(baseData.length * MAX_PERCENT_TOPICS_FOR_GENERATION)), MAX_SAMPLE_TOPICS_FOR_GENERATION)
        let selected = shuffled.slice(0, amountGeneration)
        return selected.map(topic => `- ${topic.label}`).join('\n')
    }

    self.buildTopicsLabel = function() {
        if (self.topicFilter == 'all') {
            let baseData = self.getCurrentTopics()
            let sample = baseData.slice(0, MAX_SAMPLE)

            let remaining = baseData.length - sample.length
            let otherLabel = remaining > 1 ? 'label.calendar_other_themes' : 'label.calendar_other_theme'
            let extraText = remaining > 0 ? `+${remaining} ${gettext(otherLabel)}` : ''

            self.info = {
                topics: sample,
                extra: extraText,
            }
        } else {
            self.info = {
                topics: self.getCurrentTopics(),
                extra: '',
            }
        }
    }

    self.getTopicsForGenerate = function() {
        let baseData = self.getCurrentTopics()
        if (baseData.length == 0) {
            return false
        }
        let shuffled = baseData.slice().sort(() => 0.5 - Math.random())
        let selected = shuffled.slice(0, MAX_SAMPLE_TOPICS_FOR_GENERATION)
        return selected.map(topic => `- ${topic.label}`).join('\n')
    }

    self.validateTopic = function(newTopic, existingList) {
        // Max length topic is 150
        if (!newTopic || newTopic.trim() == '' || newTopic.length <= 3 || newTopic.length > 150) {
            showError(gettext('error.calendar_topic_length'))
            return false
        }
        if (existingList && existingList.find(topic => topic.label.toLowerCase() == newTopic.toLowerCase())) {
            showError(gettext('error.calendar_topic_exists'))
            return false
        }
        return true
    }

    self.addMyTopic = function(newTopic) {
        if (!self.validateTopic(newTopic, self.temp.editing)) {
            return
        }
        let topic = {
            label: newTopic,
        }
        self.temp.editing.push(topic)
        self.temp.newTopic = ''
    }

    self.favoriteTopic = function(topic) {
        self.lists.topics.push(topic)
        self.parseTopics()
        self.saveTopics()
    }

    self.addTopic = function(topic) {
        let baseList = self.lists[self.topicFilter]
        if (!self.validateTopic(topic, baseList)) {
            return
        }
        baseList.push({
            label: topic,
        })
        self.inputs.newTopic = ''
        self.notifyChanged(self.topicFilter)
    }

    self.addTopics = function(topics, kind) {
        let baseList = self.lists[self.topicFilter]
        if (kind == 'temp') {
            baseList = self.temp.editing
        }
        for (let topic of topics) {
            if (!self.validateTopic(topic)) {
                continue
            }
            if (baseList.find(item => item.label.toLowerCase() == topic.toLowerCase())) {
                continue
            }
            baseList.push({
                label: topic,
            })
        }
        self.notifyChanged(self.topicFilter)
    }

    self.removeSelectedTopic = function(topic) {
        let baseList = self.lists[self.topicFilter]
        let index = baseList.indexOf(topic)
        baseList.splice(index, 1)

        self.notifyChanged(self.topicFilter)
    }

    self.clearSelection = function() {
        self.lists.selected.splice(0, self.lists.selected.length)
        self.notifyChanged(self.topicFilter)
        $timeout(angular.noop)
    }

    self.removeMyTopic = function(topic) {
        let index = self.temp.editing.indexOf(topic)
        self.temp.editing.splice(index, 1)
    }

    self.toggleSelectionAll = function() {
        self.temp.selection.forEach(topic => {
            topic.selected = self.inputs.bulkSelection
        })
    }

    self.initSelection = function() {
        angular.element('#themes-selection-modal').modal('show')
        let existingSelected = self.lists.selected.map(topic => topic.label)
        let existingSelectedMap = {}
        for (topic of existingSelected) {
            existingSelectedMap[topic] = true
        }
        let topics = self.lists.topics.filter(topic => !existingSelectedMap[topic.label])
        self.temp.selection = fullcopy(topics)
        // TODO - validate (all selected)
    }

    self.confirmSelection = function() {
        angular.element('#themes-selection-modal').modal('hide')
        // Get all selected from temp.selection and add to selected
        let selected = self.temp.selection.filter(topic => topic.selected)
        self.lists.selected.push(...selected)
        self.parseTopics()
        self.notifyChanged(self.topicFilter)
    }

    self.initEditing = function() {
        angular.element('#themes-edit-modal').modal('show')
        self.temp.editing = fullcopy(self.lists.topics)
    }

    self.confirmEditing = function() {
        angular.element('#themes-edit-modal').modal('hide')
        self.lists.topics = fullcopy(self.temp.editing)
        self.parseTopics()
        self.notifyChanged(self.topicFilter)
    }

    self.parseTopics = function() {
        // TODO - this is not even being called
        if (!self.lists.topics) {
            return
        }

        // Make topics unique
        let uniqueTopics = new Set()
        let topicSelection = {}
        uniqueTopics = [...new Set(self.lists.topics.map(topic => topic.label))]
        for (topic of self.lists.topics) {
            if (uniqueTopics.includes(topic.label)) {
                if (topicSelection[topic.label] === true) {
                    continue
                }
                topicSelection[topic.label] = topic.selected
            }
        }
        self.lists.topics = uniqueTopics.map(topic => {
            return {
                label: topic,
                selected: topicSelection[topic] || false
            }
        })

        // Update topics map
        self.topicsMap = {}
        for (topic of self.lists.topics) {
            self.topicsMap[topic.label.toLowerCase()] = topic
        }

        self.buildTopicsLabel()
    }

    self.useSelected = function() {
        self.topicFilter = 'selected'
        self.buildTopicsLabel()
    }

    self.useAll = function() {
        self.topicFilter = 'all'
        self.buildTopicsLabel()
    }

    self.useExplore = function() {
        self.topicFilter = 'explore'
        self.buildTopicsLabel()
    }

    self.init = function(project, config) {
        for (key in initData) {
            self[key] = initData[key]
        }
        self.project = project
        self.config = config
        self.listTopics()
    }

    return self
})